export default () => ({
  isRefundNeeded: false,
  reason: '',
  description: '',
  errors: {},
  isSavingProcess: false,
  sendEmailNotification: true,
});
